import { AccessCode, getAccessCode } from "common/api/decimal/methods/course";
import { DecimalResult } from "common/api/decimal/utils";
import { LoaderFunction, useFetcher } from "react-router-dom";

export const fetchAccessCodeAction: LoaderFunction = async ({
  request,
}): Promise<unknown> => {
  const formData = await request.formData();
  const url = formData.get("url") as string;
  if (url) {
    return getAccessCode(url);
  }
  return null;
};

export function useAccessCodeFetcher() {
  return useFetcher<DecimalResult<AccessCode>>();
}
